import React from 'react'
import { ImagemItem } from './ImagemItem'

export const ImagensCaricaturaLista = ({ images, idTabela }) => {
  return images.map((image, index) => (
    <ImagemItem key={index} idTabela={idTabela} image={image} id_imagens={images.map((image) => image.id_imagem)} />
  ))
}
